import http from "@/http/http.js";

// let baseUrl = "/api/web/action/tmQuery/springBoard";

let baseURL = "";
if (process.env.NODE_ENV == 'development') {//开发环境
  baseURL = '/api/web/action/tmQuery/springBoard';
} else if (process.env.NODE_ENV == 'production') {//生产环境
  baseURL = '/web/action/tmQuery/springBoard';
}

// 商标详情查询接口
export function tradeMarkDetail(params) {
  return http.post(baseURL, {
    actionType: "tradeMarkDetail",
    actionBody: params
  });
}

//企业查询接口
export function getCompanyInfoNoUser(name) {
  return http.post(baseURL, {
    actionType: "getCompanyInfoNoUser",
    actionBody: {
      company_name: name
    }
  });
}

// 近12期初审公告
export function noticequeryTMZCSQ() {
  return http.post(baseURL, {
    actionType: "noticequeryTMZCSQ",
    actionBody: {
      noticetype: "TMZCSQ"
    }
  });
}

// 公告列表检索接口
export function noticequery(params) {
  return http.post(baseURL, {
    actionType: "noticequery",
    actionBody: params
  });
}

// 初审公告详情查询接口
export function noticeSearch(params) {
  return http.post(baseURL, {
    actionType: "noticesearch",
    actionBody: params
  });
}

//商标精确检索接口
export function findTrademarkNameAccurate(params) {
  return http.post(baseURL, {
    actionType: "findTrademarkNameAccurate",
    actionBody: params
  });
}

//近似商标查询接口
export function findTrademarkName(params) {
  return http.post(baseURL, {
    actionType: "findTrademarkName",
    actionBody: params
  });
}

//商标申请号查询接口
export function findTrademarkzchAccurate(params) {
  return http.post(baseURL, {
    actionType: "findTrademarkzchAccurate",
    actionBody: params
  });
}

//商标申请人查询接口
export function findTrademarkzcr(params) {
  return http.post(baseURL, {
    actionType: "findTrademarkzcr",
    actionBody: params
  });
}
